import React, { useEffect, useMemo } from "react";
import styles from "./index.module.scss";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../../store";

export default function WaterMark() {
    const { userName, userNo } = useAtomValue(userAtom);

    // 这里是实现对用户隐藏水印的内容
    const dataUrl = useMemo(() => {
        const svgString = `<svg xmlns='http://www.w3.org/2000/svg' height='200px' width='200px' font-size='12' fill='rgba(0,0,0,0.3)'><text x='0' y='15' >${userName}(${userNo})</text></svg>`;
        const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
        return URL.createObjectURL(svgBlob);
    }, [userName, userNo]);

    useEffect(() => {
        return () => URL.revokeObjectURL(dataUrl);
    }, [dataUrl]);

    return (
        <div className={styles.root}>
            <div
                className={styles.wrapper}
                style={{
                    background: `url(${dataUrl})`
                }}
            />
        </div>
    );
}
